/* Recovered 2026-10-13 from code hand-appended to the dev server's dist/app.js
   (branch origin/dev-server-snapshot-2026-10-07); it had no source file. */
/* ---------------------------------------------------------------------------
   data-strip-empty — appended by hand, 2026-09-30.

   src/app/js/search-form.js implements this and is NOT in this bundle (grep it:
   zero occurrences). dist/ is stale and a clean rebuild is currently unsafe -
   it would ship an unrelated colour-system rewrite. See the matching notes in
   dist/app.css.

   THE BUG IT FIXES: a GET form submits every named control, including empty
   ones, so pressing Search with an empty box produced

       /search/hub-docs-search?q=

   and an empty q is NOT the same as an absent one. With no q the query builder
   skips the full-text clause and the search is match_all; with q= it builds a
   multi_match against an empty string, which matches nothing. Measured on this
   host: bare path 513 results, ?q= zero. The page looked broken.

   There is no way to stop a browser serialising an empty field, so when every
   field is empty this does not submit at all - it navigates straight to the
   action. getAttribute, not form.action: the property resolves to an absolute
   URL, and a same-origin path is what the rest of the site links with.

   Names are removed, not values, so a partially filled form keeps only its
   meaningful parameters; they are restored on the next tick so the form still
   works if the navigation is cancelled or the page is restored from bfcache.

   Capture phase: this must decide before any other submit handler runs.
   Delete this block once dist/ is rebuilt cleanly.
   ------------------------------------------------------------------------ */
export function initStripEmptyForm() {
	function isEmpty(f) { return !f.value || !String(f.value).trim(); }

	document.addEventListener('submit', function (e) {
		var form = e.target;
		if (!form || form.nodeType !== 1 || !form.hasAttribute('data-strip-empty')) { return; }

		var fields = Array.prototype.slice.call(
			form.querySelectorAll('input[name], select[name], textarea[name]')
		);
		if (!fields.length) { return; }

		if (!fields.filter(function (f) { return !isEmpty(f); }).length) {
			e.preventDefault();
			window.location.href = form.getAttribute('action') || window.location.pathname;
			return;
		}

		var stripped = fields.filter(isEmpty);
		stripped.forEach(function (f) {
			f.setAttribute('data-name-was', f.getAttribute('name'));
			f.removeAttribute('name');
		});
		setTimeout(function () {
			stripped.forEach(function (f) {
				var was = f.getAttribute('data-name-was');
				if (was !== null) { f.setAttribute('name', was); f.removeAttribute('data-name-was'); }
			});
		}, 0);
	}, true);
}
